$(function() {
    /**
     * Initialize Google Map in the Contact page
     */
    var $mapCanvas = $('#map');
    if ($mapCanvas.length) {
        if (typeof google === 'object' && typeof google.maps === 'object') {
            initMap();
        } else {
            loadGoogleMapsWrapper();
        }
    }
});

function loadGoogleMapsWrapper() {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDeT0lECeS9ciJqZjPzA3DKybZOxasO-6I&callback=initMap';
    document.body.appendChild(script);
}

function initMap() {
    var $map = $('#map'),
        $map_data = $('#Fieldtype_map'),
        marker_info = new String($('#markerinfo').val()),
        mapLat = $map_data.data('lat'),
        mapLng = $map_data.data('lng'),
        mapZoom = $map_data.data('zoom'),
        value = new String($map_data.val()),
        value = value.split('[===]'),
        map_settings = value[0],
        map_settings = map_settings.split('[---]');

    var mapCenter = new google.maps.LatLng(parseFloat(mapLat), parseFloat(mapLng));

    var myOptions = {
        zoom: parseInt(mapZoom),
        center: mapCenter,
        mapTypeId: 'roadmap',
        zoomControl: true,
        panControl: false,
        scrollwheel: false,
        backgroundColor: '#dedede',
        streetViewControl: false,
        scaleControl: false,
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL,
            position: google.maps.ControlPosition.RIGHT_TOP
        }
    };

    /*
     google.maps.event.addDomListener(window, "resize", function() {
     var center = map.getCenter();
     google.maps.event.trigger(map, "resize");
     map.setCenter(center);
     });
     }
     */

    this.gmap = new google.maps.Map($map.get(0), myOptions);
    this.infowindow = new google.maps.InfoWindow({maxWidth: 400});

    this.markers = new Array();

    map_clickListener(this);

    // for (var i = 1; i < value.length; i++) {
    //     var latlng = value[i];
    //     latlng = latlng.split('[---]');
    //
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(parseFloat(mapLat), parseFloat(mapLng)),
            map: this.gmap,
            _map: this,
            info: marker_info,
            draggable: false
        });
    //
        this.markers[this.markers.length] = marker;
        openInfoWindow(marker);
    //
        marker_clickListener(marker);
    // }
}

function map_clickListener(map) {
    map.clickListener = google.maps.event.addListener(map.gmap, "click", function (event) {
        map.infowindow.close();
    });
}

function marker_clickListener(marker) {
    marker.clickListener = google.maps.event.addListener(marker, "click", function () {
        openInfoWindow(marker);
    });
}

function openInfoWindow(marker) {
    if (marker.info.length > 0) {
        var content = '<div class="GMap_info_window">' + marker.info + '</div>';
        marker._map.infowindow.marker = marker;
        marker._map.infowindow.setContent(content);
        marker._map.infowindow.open(marker.map, marker);
    }
}

function initializeMap() {
    'use strict';

    var $mapCanvas = $('#map');

    var myLatlng = new google.maps.LatLng($mapCanvas.data('lat'), $mapCanvas.data('lng'));
    var mapOptions = {
        zoom: 15,
        zoomControl: true,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        panControl: false,
        backgroundColor: '#83918f',
        streetViewControl: false,
        scaleControl: false,
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL,
            position: google.maps.ControlPosition.RIGHT_TOP
        }
    };

    google.maps.visualRefresh = true;

    var map = new google.maps.Map($mapCanvas.get(0), mapOptions);

    var contentString = '<div id="info-window-content">'+
        '<div class="info-window-title">Panorama Hotel</div>'+
        '<div>' + $mapCanvas.data('address') + '</div>' +
        '</div>';

    var infowindow = new google.maps.InfoWindow({
        content: contentString
    });

    var marker = new google.maps.Marker({
        position: myLatlng,
        map: map,
        title: 'Panorama Hotel'
    });

    google.maps.event.addListener(marker, 'click', function() {
        infowindow.open(map, marker);
    });
}
